import { render, staticRenderFns } from "./DashboardHint.vue?vue&type=template&id=287a68bc"
import script from "./DashboardHint.vue?vue&type=script&lang=ts"
export * from "./DashboardHint.vue?vue&type=script&lang=ts"
import style0 from "./DashboardHint.vue?vue&type=style&index=0&id=287a68bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports